import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";
import {Picture} from "../../../model/picture";
import {Comment} from "../../../model/comment";

@Injectable()
export class PictureDetailService {
    // Observable string sources
    private pictureChangedSource = new Subject<Picture>();
    pictureChange$ = this.pictureChangedSource.asObservable();

    constructor() {

    }

    changePicture(picture:Picture) {
        this.pictureChangedSource.next(picture);
    }

    openDetail(picture:Picture) {
        this.pictureChangedSource.next(picture);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/event/picture-detail/picture-detail.service.ts